module.exports = __webpack_public_path__ + "img/woman-torso-back.5908a64b.png";